import { render, staticRenderFns } from "./BookingLog.vue?vue&type=template&id=96c39d6a&scoped=true"
import script from "./BookingLog.vue?vue&type=script&lang=js"
export * from "./BookingLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c39d6a",
  null
  
)

export default component.exports